// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__hBp9E","bannerTextContainer":"banner_bannerTextContainer__K2U4P","bannerText":"banner_bannerText__o+hp3"};